import * as React from "react";
import { Component, MouseEvent } from "react";
import { Deedle } from "components";
import { numberToCurrency } from "utils/formatters";

const scheduleTypes = {
  bi_weekly: "Bi-Weekly",
  monthly: "Monthly",
  twice_monthly: "Twice Monthly",
  weekly: "Weekly",
};

interface PropsTypes {
  onEditPress: Function;
  wageSchedule: {
    amountDeductedPerPaycheck: string;
    amountDeductedPerPaycheckWithFee: string;
    scheduleType: string;
  };
  withFee: boolean;
}

export default class PaymentScheduleInfo extends Component<PropsTypes> {
  static defaultProps = {
    withFee: true,
  };

  getAmountMap(): { label: string; value: string } {
    const {
      wageSchedule: {
        amountDeductedPerPaycheck,
        amountDeductedPerPaycheckWithFee,
      },
      withFee,
    } = this.props;

    if (withFee) {
      return {
        label: "Amount Deducted Per Paycheck with Fee",
        value: amountDeductedPerPaycheckWithFee,
      };
    }

    return {
      label: "Amount Deducted Per Paycheck",
      value: amountDeductedPerPaycheck,
    };
  }

  onEditPress = (e: MouseEvent): void => {
    e.preventDefault();
    this.props.onEditPress(e);
  };

  render(): JSX.Element {
    const amountMap = this.getAmountMap();
    const { wageSchedule } = this.props;

    return (
      <section data-test-id="paymentSchedule">
        <h2>Payment Schedule</h2>
        <a href="#" onClick={this.onEditPress}>
          Edit
        </a>
        <Deedle
          definition={numberToCurrency(amountMap.value, "$0,0.00")}
          term={amountMap.label}
        />
        <Deedle
          definition={scheduleTypes[wageSchedule.scheduleType]}
          term="Schedule Interval"
        />
      </section>
    );
  }
}
